import React from 'react';
import { Hero } from '../components/landing/hero/hero';
import { DomainList } from '../components/landing/domains/domain-list';
import { ProblemSolution } from '../components/landing/problem-solution/problem-solution';
import { HowItWorks } from '../components/landing/how-it-works/how-it-works';
import { Features } from '../components/landing/features/features';
import { Comparison } from '../components/landing/comparison/comparison';
import { Pricing } from '../components/landing/pricing/pricing';
import { Testimonials } from '../components/landing/testimonials/testimonials';
import { Cta } from '../components/landing/cta/cta';
import { SpeculationRules } from '../components/landing/ui/speculation-rules';
import usePageMeta from '../hooks/usePageMeta';

const Home: React.FC = () => {
  usePageMeta({
    title: 'BoostHiring — Structured Recruiting for Employers & Agencies',
    description:
      'BoostHiring connects employers with recruitment agencies and independent recruiters. Post jobs for free, find qualified candidates, and pay only on successful hires.',
    canonical: 'https://boosthiring.ca/',
  });

  return (
    <div className="landing-page min-h-screen bg-white font-sans">
      <main>
        <Hero />
        <DomainList />
        <ProblemSolution />
        <HowItWorks />
        <Features />
        <Comparison />
        <Pricing />
        <Testimonials />
        <Cta />
      </main>
      {/* eslint-disable react/no-danger */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                name: 'BoostHiring',
                url: 'https://boosthiring.ca',
                logo: 'https://boosthiring.ca/favicon-512.png',
                description:
                  'SaaS marketplace connecting employers with recruitment agencies and independent recruiters.',
                areaServed: [
                  { '@type': 'Country', name: 'United States' },
                  { '@type': 'Country', name: 'Canada' },
                ],
                sameAs: [
                  'https://www.linkedin.com/company/boosthiring',
                  'https://x.com/BoostHiringHQ',
                  'https://www.instagram.com/boosthiring',
                  'https://www.facebook.com/profile.php?id=61590933320508',
                ],
              },
              {
                '@type': 'WebSite',
                name: 'BoostHiring',
                url: 'https://boosthiring.ca',
              },
              {
                '@type': 'SoftwareApplication',
                name: 'BoostHiring',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web',
                url: 'https://boosthiring.ca',
                description:
                  'BoostHiring connects employers with recruitment agencies and independent recruiters. Post jobs for free, find qualified candidates, and pay only on successful hires.',
                areaServed: [
                  { '@type': 'Country', name: 'United States' },
                  { '@type': 'Country', name: 'Canada' },
                ],
                offers: {
                  '@type': 'Offer',
                  price: '0',
                  priceCurrency: 'CAD',
                  description: 'Free for employers. Post unlimited jobs.',
                },
              },
            ],
          }),
        }}
      />
      <SpeculationRules />
    </div>
  );
};

export default Home;
